<template>
    <div class="index">
        <el-row class="tags">
            <el-col :span="6">
                <div class="tag_item">
                    <ul>
                        <li>
                            <img :src="require('@/assets/document.png')"/>
                        </li>
                        <li>
                            <p class="tag_title">今日订单总数</p>
                            <p class="tag_value">
                                <b>200</b>
                            </p>
                        </li>
                    </ul>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="tag_item">
                    <ul>
                        <li>
                            <img :src="require('@/assets/document.png')"/>
                        </li>
                        <li>
                            <p class="tag_title">昨日订单总数</p>
                            <p class="tag_value">
                                <b>200</b>
                            </p>
                        </li>
                    </ul>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="tag_item">
                    <ul>
                        <li>
                            <img :src="require('@/assets/polyline.png')"/>
                        </li>
                        <li>
                            <p class="tag_title">近7天订单数</p>
                            <p class="tag_value">
                                <b>200</b>
                            </p>
                        </li>
                    </ul>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="tag_item">
                    <ul>
                        <li>
                            <img :src="require('@/assets/document.png')"/>
                        </li>
                        <li>
                            <p class="tag_title">今日销售总额</p>
                            <p class="tag_value">
                                <b>200</b>
                            </p>
                        </li>
                    </ul>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="tag_item">
                    <ul>
                        <li>
                            <img :src="require('@/assets/currency.png')"/>
                        </li>
                        <li>
                            <p class="tag_title">平台订单总数</p>
                            <p class="tag_value">
                                <b>￥1000.00</b>
                            </p>
                        </li>
                    </ul>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="tag_item">
                    <ul>
                        <li>
                            <img :src="require('@/assets/currency.png')"/>
                        </li>
                        <li>
                            <p class="tag_title">昨日销售总额</p>
                            <p class="tag_value">
                                <b>￥1000.00</b>
                            </p>
                        </li>
                    </ul>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="tag_item">
                    <ul>
                        <li>
                            <img :src="require('@/assets/currency.png')"/>
                        </li>
                        <li>
                            <p class="tag_title">近7天销售总额</p>
                            <p class="tag_value">
                                <b>￥700.00</b>
                            </p>
                        </li>
                    </ul>
                </div>
            </el-col>
            <el-col :span="6">
                <div class="tag_item">
                    <ul>
                        <li>
                            <img :src="require('@/assets/currency.png')"/>
                        </li>
                        <li>
                            <p class="tag_title">平台总销售额</p>
                            <p class="tag_value">
                                <b>￥123000.00</b>
                            </p>
                        </li>
                    </ul>
                </div>
            </el-col>
        </el-row>
        <el-row class="tags">
            <el-col :span="12">
                <div class="tag_item">
                    <p class="tag_head">医生总览</p>
                    <ul class="padect">
                        <li>
                            <h1>420</h1>
                            <p>医生总数</p>
                        </li>
                        <li>
                            <h1>420</h1>
                            <p>在线医生数</p>
                        </li>
                        <li>
                            <h1>420</h1>
                            <p>近一周新注册</p>
                        </li>
                        <li>
                            <h1>420</h1>
                            <p>停诊医生数</p>
                        </li>
                    </ul>
                    <div style="clear:both"></div>
                </div>
            </el-col>
            <el-col :span="12">
                <div class="tag_item">
                    <p class="tag_head">医生总览</p>
                    <ul class="padect">
                        <li>
                            <h1>420</h1>
                            <p>会员总数</p>
                        </li>
                        <li>
                            <h1>420</h1>
                            <p>昨日新增</p>
                        </li>
                        <li>
                            <h1>420</h1>
                            <p>今日新增</p>
                        </li>
                        <li>
                            <h1>420</h1>
                            <p>本月新增</p>
                        </li>
                    </ul>
                    <div style="clear:both"></div>
                </div>
            </el-col>
        </el-row>
        <el-row class="tags">
            <el-col :span="24">
                <div class="tag_item">
                    <p class="tag_head">订单统计</p>
                    <div></div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {};
        }
    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .tags .el-col {
        padding: 15px;
    }

    .tag_item {
        border: 1px solid rgba(228, 228, 228, 1);
        width: 100%;
        min-height: 100px;
    }

    .tag_item ul {
        padding-top: 15px;
        clear: both;
    }

    .tag_item ul li {
        float: left;
        list-style: none;
        padding-right: 20px;
    }

    .tag_item .tag_title,
    .tag_item .tag_value {
        text-align: left;
        margin: 0;
    }

    .tag_item .tag_value {
        font-size: 20px;
    }

    .tag_item .tag_head {
        background-color: rgba(228, 228, 228, 1);
        margin: 0px;
        padding: 10px 10px;
        text-align: left;
        font-size: 14px;
        border-bottom: 1px solid rgba(228, 228, 228, 1);
    }

    .tag_item .padect li {
        // font-size: 28px;
        margin: 0px 8% 40px 3%;
    }

    .tag_item .padect li p,
    .tag_item .padect li h1 {
        margin: 0px;
    }

    .tag_item .padect li h1 {
        font-size: 1.8em;
    }

    .tag_item .padect li p {
        font-size: 15px;
    }
</style>


